import { useContext } from 'react'
import { useStore } from 'zustand'

import { SchemaContext, SchemaProps, SchemaStore } from './schema-provider'

export const useSchema = (selector?: any) => {
  const store = useContext(SchemaContext)

  if (!store) {
    throw new Error('useSchema must be used within a SchemaProvider')
  }

  return useStore<SchemaStore, SchemaProps>(store, selector)
}
